<template>
  <v-layout class="doc-direction">
    <v-icon size="16" class="direction-icon">{{icon}}</v-icon>
    <span class="direction-title">{{$t('document.direction.matter.' + direction)}}</span>
  </v-layout>
</template>

<script>
  export default {
    name: "DocDirection",
    props: {
      direction: {
        type: String,
        required: true,
        validator: prop => ['business_to_client', 'client_to_business', 'internal'].includes(prop),
      },
    },
    computed: {
      icon() {
        const icons = {
          business_to_client: 'icon-Outgoing',
          client_to_business: 'icon-Incoming',
          internal: 'icon-internal',
        }

        return icons[this.direction]
      },
    }
  };
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';

.doc-direction {

  .direction-title {
    font-family: var(--primary-font-family);
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: normal;
    text-transform: uppercase;
    @include i-margin-mirror(4px, 0);
  }

  .direction-icon, .direction-title {
    color: $black-color-1;
  }
}
</style>
